/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import useAggregateListTwo from '../hooks/useAggregateListTwo';
// import useAggregatePriceForStone from '../hooks/useAggregatePriceForStone';
import useAggregateHistoryPriceForStone from '../hooks/useAggregateHistoryPriceForStone';
import { BarEchart } from '@/components/page-echarts';
export default defineComponent({
  name: 'AggregatePrice',
  components: {
    BarEchart: BarEchart
  },
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  setup: function setup(props) {
    watch(function () {
      return props.type;
    }, function () {
      activeName.value = [];
    });
    // const params = ref({
    //   stoneName: ''
    // })
    var trendParams = ref({
      stoneName: '',
      stoneSpecName: ''
    });
    //获取骨料销售列表
    var _useAggregateListTwo = useAggregateListTwo(),
      _useAggregateListTwo2 = _slicedToArray(_useAggregateListTwo, 2),
      aggregateList = _useAggregateListTwo2[0],
      getSalesPriceListAsync = _useAggregateListTwo2[1];
    // const [aggregatePriceList, getAggregatePriceForStoneAsync] =
    //   useAggregatePriceForStone(params)
    var _useAggregateHistoryP = useAggregateHistoryPriceForStone(trendParams),
      _useAggregateHistoryP2 = _slicedToArray(_useAggregateHistoryP, 2),
      aggregatePriceTrend = _useAggregateHistoryP2[0],
      getPriceTrendAsync = _useAggregateHistoryP2[1];
    var onChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // params.value.stoneName = stone_name
              // trendParams.value.stoneName = stone_name
              //二级折叠面板默认不选中
              activeNames.value = '';
              //根据石料名称获取价格列表
              // getAggregatePriceForStoneAsync()
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onChange() {
        return _ref.apply(this, arguments);
      };
    }();
    var changeUser = function changeUser(stone_name, stoneSpecName, stone_name_origin) {
      console.log(222, stone_name, stoneSpecName);
      activeNames.value = stone_name;
      trendParams.value.stoneName = stone_name_origin;
      trendParams.value.stoneSpecName = stoneSpecName;
      getPriceTrendAsync();
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getSalesPriceListAsync();
          case 2:
            activeName.value = aggregateList.value.map(function (item) {
              return item.stone_name;
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    var activeName = ref([]);
    var activeNames = ref('');
    var saleVolumn = computed(function () {
      var lineData = aggregatePriceTrend.value.map(function (item) {
        return item.sale_price;
      });
      var xLabels = aggregatePriceTrend.value.map(function (item) {
        return item.update_time.split(' ')[0];
      });
      var legendData = [''];
      return {
        xLabels: xLabels,
        lineData: lineData,
        legendData: legendData,
        color: '#82A3FF',
        grid: {
          left: 40,
          top: 10,
          bottom: 20,
          right: 20
        },
        customTooltip: true,
        formatter: function formatter(params) {
          console.log(11, params);
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">\u552E\u4EF7</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value, "\u5143\n            </span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var dateFormat = function dateFormat(val) {
      return dayjs(val).format('YYYY/MM/DD');
    };
    return {
      activeName: activeName,
      activeNames: activeNames,
      onChange: onChange,
      saleVolumn: saleVolumn,
      aggregateList: aggregateList,
      // aggregatePriceList,
      changeUser: changeUser,
      dateFormat: dateFormat
    };
  }
});